<template>
  <div>
    <QCChartResult></QCChartResult>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const QCChartResult = defineAsyncComponent(() =>
  import("@/components/QCCharts/QCChartResult")
);
export default {
  components: {
    QCChartResult,
  },
};
</script>
